import { render, staticRenderFns } from "./RsaConfigurazioneLaboratoriViewPage.vue?vue&type=template&id=2bbdeb34"
import script from "./RsaConfigurazioneLaboratoriViewPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneLaboratoriViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports